import { FormatPriceUtils } from './../../../../../utils/format-price-utils';
import { inject, Injectable } from '@angular/core';

import { PaymentStore } from '../store/payment-report.store';
import { TranslateService } from '@ngx-translate/core';
import { formatNetworkName } from 'src/app/utils/network-utils';
// import { decimalPlacesFor } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentUtils {
  private paymentStore = inject(PaymentStore);
  private formatPriceUtils = inject(FormatPriceUtils);
  private translate = inject(TranslateService);

  get paymentDetails() {
    return this.paymentStore.paymentDetailsComputed();
  }

  public isCommaDecimal = this.formatPriceUtils.isCommaDecimal();

  formatPrice(value: string | number, payingAsset?: boolean): string {
    const assetTicker = payingAsset
      ? this.paymentDetails.settlementAsset?.assetTicker
      : this.paymentDetails.payingAsset?.assetTicker;

    if (!value || !assetTicker) return '';

    return this.formatPriceUtils.formatPrice(value, assetTicker || 'USD');
  }

  getNetworkName(anyNetwork?: string) {
    this.paymentStore.paymentDetailsComputed().payingAsset;
    const networkId = this.paymentStore.paymentDetailsComputed().payingAsset?.assetChain || '';

    return formatNetworkName(anyNetwork || networkId);
  }

  sameAssets() {
    const payingAsset = this.paymentDetails.payingAsset?.assetTicker;
    const settlementAsset = this.paymentDetails.settlementAsset?.assetTicker;

    return payingAsset === settlementAsset;
  }

  formatTimer(secondsString: string): string {
    const sec_num = parseInt(secondsString, 10);
    const hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - hours * 3600) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60;

    if (minutes < 10) {
      minutes = Number(`0${minutes}`);
    }
    if (seconds < 10) {
      seconds = Number(`0${seconds}`);
    }

    return ` ${minutes >= 10 ? '' : '0'}${minutes}:${seconds.toString().length < 2 ? '0' + seconds : seconds}`;
  }

  getCoinMarketTooltip() {
    return this.translate.instant('thisConversionRatesComesFrom', {
      payingAsset: this.paymentDetails.payingAsset?.assetTicker,
      settlementAsset: this.paymentDetails.settlementAsset?.assetTicker,
      lineBreak: '\n\n',
    });
  }
}
